import {
  createBreakpointConverter
} from "./chunk.MIOPVZYG.js";

// src/components/stepper/stepper.type.ts
var orientationTypes = ["horizontal", "vertical"];
var OrientationPropertyConverter = createBreakpointConverter(orientationTypes);

export {
  orientationTypes,
  OrientationPropertyConverter
};
